import styled from "styled-components";

export const QuickFactsSectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 3.2rem;
`;

export const QuickFacts = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 2rem;
`;
